// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/hooks/useRoomContext.ts"
);
import.meta.hot.lastModified = "1748231560011.9688";
}
// REMIX HMR END

import { useOutletContext } from '@remix-run/react'
import type { PartyTracks } from 'partytracks/client'
import type { Dispatch, SetStateAction } from 'react'
import type { UserMedia } from '~/hooks/useUserMedia'
import type useRoom from './useRoom'
import type { useRoomHistory } from './useRoomHistory'
import type { GoogleUser } from '~/services/auth.server'

export type RoomContextType = {
	traceLink?: string
	feedbackEnabled: boolean
	userDirectoryUrl?: string
	joined: boolean
	setJoined: Dispatch<SetStateAction<boolean>>
	pinnedTileIds: string[]
	setPinnedTileIds: Dispatch<SetStateAction<string[]>>
	showDebugInfo: boolean
	setShowDebugInfo: Dispatch<SetStateAction<boolean>>
	audioOnlyMode: boolean
	setAudioOnlyMode: Dispatch<SetStateAction<boolean>>
	dataSaverMode: boolean
	setDataSaverMode: Dispatch<SetStateAction<boolean>>
	userMedia: UserMedia
	partyTracks: PartyTracks
	iceConnectionState: RTCIceConnectionState
	room: ReturnType<typeof useRoom>
	roomHistory: ReturnType<typeof useRoomHistory>
	simulcastEnabled: boolean
	pushedTracks: {
		video?: string
		audio?: string
		screenshare?: string
	}
	currentUser?: GoogleUser | null
}

export function useRoomContext() {
	return useOutletContext<RoomContextType>()
}
